import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "relative w-full" }
const _hoisted_3 = {
  key: 0,
  class: "absolute top-0 left-0 w-full h-full bg-white bg-opacity-60"
}

import { ref, computed } from "vue"
import flatPickr from "vue-flatpickr-component"
import "flatpickr/dist/flatpickr.css"
import { formatDateToIso } from "@/shared/utils/helpers"

interface Props {
    position?: string
    modelValue: string | Date | undefined
    showTime?: boolean
    showDate?: boolean
    label?: string
    id?: string
    disabled?: boolean
    inline?: boolean
    minDate?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsCalendar',
  props: {
    position: {},
    modelValue: {},
    showTime: { type: Boolean },
    showDate: { type: Boolean },
    label: {},
    id: {},
    disabled: { type: Boolean },
    inline: { type: Boolean, default: true },
    minDate: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

let internalValue = ""

const config = ref({
    position: props.position,
    enableTime: props.showTime,
    noCalendar: !props.showDate,
    minDate: props.minDate,
})

const inputValue = computed({
    get: () => {
        if (props.modelValue !== internalValue) {
            internalValue = String(props.modelValue) ?? ""
            if (props.modelValue instanceof Date && !isNaN(props.modelValue.getTime())) {
                const date = new Date(props.modelValue)
                const newDate = new Date(date.getTime())
                return newDate.toISOString().slice(0, -1)
            } else if (typeof props.modelValue === "string") {
                return formatDateToIso(props.modelValue).slice(0, -1)
            }
        }
        return internalValue
    },
    set: (value: string | Date) => {
        internalValue = String(value)
        emit("update:modelValue", value)
    },
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.inline ? '' : 'flex-col', 'flex'])
  }, [
    _createElementVNode("label", {
      for: _ctx.id,
      class: _normalizeClass([_ctx.disabled ? 'opacity-40' : '', 'block mb-1 text-sm font-medium text-gray-700'])
    }, _toDisplayString(_ctx.label), 11, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(flatPickr), {
        modelValue: inputValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
        config: config.value,
        id: _ctx.id,
        class: "appearance-none block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none placeholder-gray-400 focus:ring-primary-color-500 focus:border-primary-color-500 border-gray-300 text-base"
      }, null, 8, ["modelValue", "config", "id"]),
      (_ctx.disabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})